.root {
  display: inline-grid;
  justify-items: center;
  text-align: center;
}

.chart {
  display: block;
}

.label {
  margin-top: 0.35em;
  color: var(--color-text);
  font-family: var(--font-family-base);
  line-height: 1.2;
  white-space: pre-wrap;
}

.label_compact {
  margin-top: 0.2em;
}

.sizeSmall .label {
  font-size: 0.5em;
  max-width: 6em;
}

.sizeMedium .label {
  font-size: 0.667em;
  max-width: 7em;
}

.sizeLarge .label {
  font-size: 0.833em;
  max-width: 8em;
}
